import { render, staticRenderFns } from "./TroubleShootTask.vue?vue&type=template&id=071559f4&scoped=true"
import script from "./TroubleShootTask.vue?vue&type=script&lang=js"
export * from "./TroubleShootTask.vue?vue&type=script&lang=js"
import style0 from "./TroubleShootTask.vue?vue&type=style&index=0&id=071559f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071559f4",
  null
  
)

export default component.exports